export default "__VITE_ASSET__ed66af07__"